import React from "react";

const ManageProduct = () => {
  return (
    <div>
      <h2>This is a Manage Product Section </h2>
    </div>
  );
};

export default ManageProduct;
